<template>
    <hr />
    <p>问题：当内容区域出现错误了，会导致切换菜单功能失效</p>
    <p>html 展示错误数据：{{user.info.name}}</p>
</template>

<script>
export default {
    name: "error.vue",
    data() {
        return {
            user: {}
        }
    },
    created() {
        this.user.info.name
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
